//import React from 'react';
import { connect } from 'react-redux';
import ItemQueueView from '../components/ItemQueueView'
import { getItemIds, getItemsById } from '../../reducer';

const mapStateToProps = (state) => {
  return {
    item_ids: getItemIds(state),
    items_by_id: getItemsById(state)
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    // onSubmit: ({pin}) => {
    //   dispatch(submitCodeLoginForm(pin,window.getCookie("udid")));
    // }
  }
}

export const ItemQueue = connect(mapStateToProps,mapDipatchToProps)(ItemQueueView);

export default ItemQueue;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/ItemQueue.js